export default {"src":"/_next/static/media/MyTasks.cbd77723.svg","height":80,"width":80,"blurWidth":0,"blurHeight":0};